module.exports = __webpack_public_path__ + "bn.8ba60fe3f4bbd12ddc83.svg";


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/lednube/theme/scss/icons/flag-icon-css/flags/bn.svg
// module id = ../../../../../theme/scss/icons/flag-icon-css/flags/bn.svg
// module chunks = styles